export default __webpack_public_path__ + "static/media/PortableMiner.256.15fca453.png";